import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles(theme => ({
  root: { display: "flex", flexDirection: "column", alignItems: "center" },
  inputs: {
    marginTop: theme.spacing(2),
  },
}));
